<script setup lang="ts">

interface Props {
    tab: string;
    value: string;
}

const props = defineProps<Props>();
const emit = defineEmits<{ click: [] }>()
</script>

<template>
    <v-tab
        :value="props.value"
        @click="emit('click')"
    >
        <div
            class="text-black"
            :class="{
                'font-weight-bold': props.tab === props.value,
                'font-weight-regular': props.tab !== props.value,
            }"
        >
            <slot />
        </div>
    </v-tab>
</template>

<style scoped>

</style>
